// extracted by mini-css-extract-plugin
export var actionButton = "_kz-0";
export var actionMenuContainer = "_kz-i";
export var bubble = "_kz-2";
export var bubbleActionMenu = "_kz-j";
export var bubbleContext = "_kz-6";
export var bubbleItems = "_kz-7";
export var customer = "_kz-3";
export var divider = "_kz-8";
export var fileList = "_kz-9";
export var hiddenComment = "_kz-o";
export var infoAbove = "_kz-a";
export var internal = "_kz-4";
export var lightActionButton = "_kz-1";
export var link = "_kz-b";
export var merchant = "_kz-5";
export var message = "_kz-c";
export var profilePicture = "_kz-e";
export var quillToolbarContainer = "_kz-f";
export var senderDate = "_kz-g";
export var senderDateCustomer = "_kz-h";
export var senderName = "_kz-d";
export var time = "_kz-k";
export var uploadedImage = "_kz-l";
export var username = "_kz-m";
export var xsmall = "_kz-n";